import { ArrowLeft, ShieldAlert } from 'lucide-react';
import { Link } from 'react-router';

import { EmptyState } from '@/components/shared/empty-state';
import { Button } from '@/components/ui/button';

export function UnauthorizedPage() {
  return (
    <div className="py-10">
      <EmptyState
        icon={ShieldAlert}
        title="No tienes permisos para acceder a esta sección"
        description="Tu rol actual no permite ver este módulo. Si lo necesitas, solicita acceso a un superadministrador."
        action={
          <Button asChild variant="secondary" size="sm">
            <Link to="/dashboard">
              <ArrowLeft aria-hidden="true" />
              Ir al panel general
            </Link>
          </Button>
        }
      />
    </div>
  );
}
